import { module, bootstrap } from "angular";
import sportIconDirective from "../../partials/sport-icon/sport-icon.directive";
import teamIconDirective from "../../partials/icons/team-icon/team-icon.directive";
import { addGTMTag, generalConfig, /*rollbarConfig*/ } from "../general";
import "./value-bets.scss";
import { ShortlistService } from "../../services/shortlist.service";
import { MatchService } from "../../services/match.service";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
import { SportDataService } from "../../services/sport-data.service";
import flagIconDirective from "../../partials/icons/flag-icon/flag-icon.directive";
import { nthFilter } from "../../filters/nth.filter";
import { GeneralService } from "../../services/general.service";
import { BetService } from "../../services/bet.service";
import valueBetsBlockComponent from "./value-bets.component";

function loadSingleSiValueBets(config: BlockConfigurationObject): Promise<void> {
	return new Promise((resolve, reject) => {
		if (config.sports) {
			// remove case-sensitivity for sport codes
			config.sports.forEach(s => s = s.toUpperCase());
			// determine target element
			if (!config.targetElementID) {
				config.targetElementID = "si-external-value-bets";
			}
			const targetElement = document.getElementById(config.targetElementID);
			if (targetElement !== null) {
				if (config.debugMode) {
					targetElement.innerHTML = "Loading Value Bets Block...";
				}
		
				if (config.publicationTheme) {
					
					require("../../publisher-themes/" + config.publicationTheme + ".scss");
				}

				targetElement.innerHTML = "<si-external-value-bets></si-external-value-bets>";
	
				addGTMTag(config);

				module("siExternalValueBets", [require("angular-sanitize"), /* 'ngAnimate',*/ /*require("ng-rollbar")*/])
					.value("configurationObject", config)
					.value("apiDomain", process.env.API_DOMAIN)
					.constant("blockDomain", process.env.BLOCK_DOMAIN)
					.constant("cdnDomain", process.env.CDN_DOMAIN)
					.service("sportDataService", SportDataService)
					.filter("nth", nthFilter)
					.service("generalService", GeneralService)
					.service("matchService", MatchService)
					.service("shortlistService", ShortlistService)
					.service("betService", BetService)
					.directive("teamIconSport", teamIconDirective)
					.directive("flagIconCountry", flagIconDirective)
					.directive("sportIconCode", sportIconDirective)
					.config(generalConfig)
					.component("siExternalValueBets", valueBetsBlockComponent)
					// .config(["RollbarProvider", rollbarConfig]);

				bootstrap(targetElement, ["siExternalValueBets"], {strictDi: true});

				resolve();

			} else {
				reject(`Target element (#${config.targetElementID}) not found`);
			}
		} else {
			reject("Configuration object found, but required parameter 'sports' not found within");
		}
	});
}

function loadSiValueBets(config: BlockConfigurationObject): Promise<void> {
	return new Promise((resolve, reject) => {
		console.log("SI Loader script called");
		if (config) {
			if (Array.isArray(config)) {
				config.reduce((previousPromise, nextConfig) => {
					return previousPromise.then(() => {
						return loadSingleSiValueBets(nextConfig);
					}, (err) => {
						console.error("Value Bets Block failed: " + err);
						return loadSingleSiValueBets(nextConfig);
					});
				}, Promise.resolve()).then(resolve);
			} else {
				loadSingleSiValueBets(config).then(() => {
					console.log("Value Bets Block Successfully Loaded");
					resolve();
				}, (err) => {
					console.log(`Value Bets Block failed: ${err}`);
					reject(`Value Bets Block failed: ${err}`);
				});
			}
		} else {
			console.log("Configuration object (config) not found");
			reject("Configuration object (config) not found");
		}
	});
}

if (typeof window !== undefined) {
	window["loadSiValueBets"] = loadSiValueBets;
}
export { loadSiValueBets };
